import { render, staticRenderFns } from "./SuiviIndividu.vue?vue&type=template&id=1626d1c6&scoped=true&"
import script from "./SuiviIndividu.vue?vue&type=script&lang=js&"
export * from "./SuiviIndividu.vue?vue&type=script&lang=js&"
import style0 from "./SuiviIndividu.vue?vue&type=style&index=0&id=1626d1c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1626d1c6",
  null
  
)

export default component.exports